export default __webpack_public_path__ + "static/media/nutrasite-screenshot.4d9512ef.png";